module.exports = __webpack_public_path__ + "static/media/dice-4.ac533eda.svg";